/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { Row, Col, Card, CardBody, Table, Tooltip } from 'reactstrap';
import { RiErrorWarningLine } from "react-icons/ri";
import { LoaderMini } from '~/components/Loaders';
import { Text } from '~/components/Text';
import { color } from '~/assets/styles/colors';
import { symbolPriceFormatter } from '~/helpers/price';
import money from '../../../assets/img/money.svg';
import setaBaixa from '../../../assets/img/iconExtrato/setaBaixa.svg';

import setaCima from '../../../assets/img/iconExtrato/setaCima.svg';
import {
	DivMontante,
	ImgMontante,
	TextMontante,
	TdExtrato,
	TrExtrato,
	ThExtrato,
	TheadExtrato,
	TbodyExtrato
} from './styles';

export function ExtratoSimples(props) {

	const { user, extratos } = props;
	const [tooltipDescricao, setTooltipDescricao] = useState(null);
	const toggleTooltip = (itemId) => {
		setTooltipDescricao(tooltipDescricao === itemId ? null : itemId);
	};


	return (
		<Table id="test-table-xls-button" responsive>
			<TheadExtrato>
				<TrExtrato>
					<>
						<ThExtrato>Dt Lançamento</ThExtrato>
						{user.dados.cargo.toLowerCase() === 'industria' || (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && user.dados.permissoes.distribuidor_ems === false) ? <ThExtrato>ID Origem</ThExtrato> : <></>}
						<ThExtrato>Motivo</ThExtrato>
						{user.dados.permissoes.distribuidor_ems === false ? <ThExtrato>Nº Documento</ThExtrato> : <></>}

						{user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' ? <ThExtrato style={{ textAlign: 'left', paddingLeft: 22 }}>Origem</ThExtrato> : <></>}
						{user.dados.cargo.toLowerCase() === '' ? <ThExtrato>Venda</ThExtrato> : <></>}
						<ThExtrato>V. Bruto</ThExtrato>
						{/* <ThExtrato>Taxa (R$)</ThExtrato>
				<ThExtrato>V. Líquido</ThExtrato> */}
						<ThExtrato>Cred. Gerado</ThExtrato>
						<ThExtrato>Tipo</ThExtrato>
						<ThExtrato>Valores</ThExtrato>
					</>
				</TrExtrato>
			</TheadExtrato>
			<TbodyExtrato>
				{extratos.map((item, index) => {
					return (
						<>
							<TrExtrato key={`${item.numero_documento}-${index}`}>
								<TdExtrato>
									{item.data_lancamento}
								</TdExtrato>
								{
									user.dados.cargo.toLowerCase() === 'industria' || (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && user.dados.permissoes.distribuidor_ems === false)
										?
											<TdExtrato>{item.lojista_id}</TdExtrato>
										: <></>
								}

								<TdExtrato>
									<p style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
									{item.descricao_rastreamento ? item.descricao_rastreamento  : "" }
									{
										(item.ajuste_descricao) && (
											<div>

												<p id={`Tooltip-${index}`} style={{marginTop: "10px",paddingLeft: "10px", color: color.red}}>
													<RiErrorWarningLine />
												</p>
												<Tooltip
													placement="top"
													isOpen={tooltipDescricao === index}
													target={`Tooltip-${index}`}
													toggle={() =>  toggleTooltip(index)}
												>
													{`${item.ajuste_descricao}`}
												</Tooltip>
											</div>
										)
									}
									</p>


								</TdExtrato>
								{user.dados.permissoes.distribuidor_ems === false ? <TdExtrato>{item.documento}</TdExtrato> :  <></>}
								{
									user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor'
										? (
											user.dados.permissoes.distribuidor_ems === false
											? <TdExtrato style={{ textAlign: 'left' }}>{item.lojista_nome}</TdExtrato>
											: <TdExtrato>{item.tipo === 'DB' ? item.distribuidor_nome : item.lojista_nome}</TdExtrato>
										)
										: <></>
								}
								{user.dados.cargo.toLowerCase() === '' ?
									<TdExtrato>
										{item.tipo === 'CR' ? symbolPriceFormatter(item.venda) : '-'}
									</TdExtrato> : <></>}
								<TdExtrato>{item.tipo === 'CR' ? symbolPriceFormatter(item.bruto) : '-'}</TdExtrato>
								{/* <TdExtrato>{item.tipo === 'CR' ? symbolPriceFormatter(item.taxa) : '-'}</TdExtrato>
					<TdExtrato>{item.tipo === 'CR' ? symbolPriceFormatter(item.liquido) : '-'}</TdExtrato> */}
								<TdExtrato>{item.tipo === 'CR' ? symbolPriceFormatter(item.credito) : '-'}</TdExtrato>
								<TdExtrato>{item.tipo === 'CR' || item.valores > 0 ? 'Crédito' : 'Débito'}</TdExtrato>
								<TdExtrato style={{ color: item.tipo === 'CR' || item.valores > 0 ? color.green : color.red }}>
									{item.tipo === 'CR' || item.valores > 0 ?
										<ImgMontante
											alt="setaCima"
											width="15"
											src={setaCima}
										/> :
										<ImgMontante
											alt="setaBaixa"
											width="15"
											src={setaBaixa}
										/>}
									{symbolPriceFormatter(item.valores)}
								</TdExtrato>
							</TrExtrato>
						</>
					);
				})}
			</TbodyExtrato>
		</Table>
	);
}

export function CardSimples(props) {
	const { loadingExtrato, dataSaldo, user } = props;
	const isDistribuidor = user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor';
	const cardSimples = [
		...(!isDistribuidor ? [
			{
				id: 0,
				nome: 'Total em Vendas',
				nome_index: 'total_venda',
				color: 'gray',
				bg_color: color.yellow,
			},
			{
				id: 1,
				nome: 'Saldo Bruto',
				nome_index: 'saldo_bruto',
				color: 'white',
				bg_color: color.gray,
			},
			{
				id: 2,
				nome: 'Saldo Líquido',
				nome_index: 'saldo_liquido',
				color: 'white',
				bg_color: color.gray,
			},
		] : []),
		{
			id: 3,
			nome: 'Creditados',
			nome_index: 'credito',
			color: 'green',
			bg_color: color.white,
		},
		{
			id: 4,
			nome: 'Debitados',
			nome_index: 'debito',
			color: 'red',
			bg_color: color.white,
		}
	];

	return (
		<Row className="mt-5">
			{cardSimples.map((item, index) => (
				<Col key={`${item.id}-${index}`}>
					<Text style={{ textAlign: 'right' }}>{item.nome}</Text>
					<Card
						style={{
							marginBottom: 0,
							backgroundColor: item.bg_color,
							borderRadius: '0 10px 10px 10px',
							border: isDistribuidor ? '1px solid' : '',
						}}>
						<CardBody className="py-4 px-2">
							{loadingExtrato ? (
								<div className="d-flex justify-content-center">
									<LoaderMini />
								</div>
							) : (
								<Text
									color={item.color}
									size="big"
									center>
									{symbolPriceFormatter(
										dataSaldo[item.nome_index]
									)}
								</Text>
							)}
						</CardBody>
					</Card>
				</Col>
			))}
			<Col lg={isDistribuidor ? { size: 3, offset: 5 } : 2} md="4">
				<Text style={{ textAlign: 'right' }}>
					Meus Créditos
				</Text>
				<Card
					style={{
						marginBottom: 0,
						backgroundColor: color.secondary,
					}}>
					<CardBody className="py-4 px-2">
						{loadingExtrato ? (
							<div className="d-flex justify-content-center">
								<LoaderMini />
							</div>
						) : (
							<DivMontante>
								<TextMontante
									style={{ marginRight: '5%' }}>
									<Text
										color="softBlack"
										size="big"
										center>
										{symbolPriceFormatter(
											dataSaldo.saldo
										)}
									</Text>
								</TextMontante>
								<ImgMontante
									alt="money"
									width="20"
									src={money}
								/>
							</DivMontante>
						)}
					</CardBody>
				</Card>
			</Col>
		</Row>
	);
}
